import { render } from "./RecipeViewer.vue?vue&type=template&id=421cb8c4"
import script from "./RecipeViewer.vue?vue&type=script&lang=js"
export * from "./RecipeViewer.vue?vue&type=script&lang=js"

import "./RecipeViewer.vue?vue&type=style&index=0&id=421cb8c4&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__